<footer class="sidebar-user-footer user-section px-3 py-3 d-flex flex-column align-items-stretch gap-2 border-top border-top">

  <router-link
    v-if="is_admin"
    to="/user_management"
    class="sidebar-user-management-link d-flex align-items-center text-decoration-none w-100 rounded"
    aria-label="Open access control"
    data-tooltip="Access Control"
  >
    <span class="bcx-icon-chip bcx-icon-chip-sm sidebar-footer-icon-chip flex-shrink-0 me-2">
      <i class="bi bi-person-gear"></i>
    </span>

    <span class="sidebar-user-management-text sidebar-menu-text text-white-50 fw-semibold text-xs">
      Access Control
    </span>
  </router-link>

  <router-link
    to="/settings"
    class="sidebar-user-management-link d-flex align-items-center text-decoration-none w-100 rounded"
    aria-label="Open configuration"
    data-tooltip="Configuration"
  >
    <span class="bcx-icon-chip bcx-icon-chip-sm sidebar-footer-icon-chip flex-shrink-0 me-2">
      <i class="bi bi-sliders"></i>
    </span>

    <span class="sidebar-menu-text text-white-50 fw-semibold text-xs">
      Configuration
    </span>
  </router-link>

  <a
    href="#"
    class="sidebar-user-management-link d-flex align-items-center text-decoration-none w-100 rounded"
    aria-label="Sign out"
    data-tooltip="Sign Out"
    @click.prevent="logoutUser"
  >
    <span class="bcx-icon-chip bcx-icon-chip-sm sidebar-footer-icon-chip flex-shrink-0 me-2">
      <i class="bi bi-door-open"></i>
    </span>

    <span class="sidebar-menu-text text-white-50 fw-semibold text-xs">
      Sign Out
    </span>
  </a>

</footer>
